var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history-address"},[_c('ul',_vm._l((_vm.historyList),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.goToDetail(item)}}},[_vm._v(_vm._s(item.region)+_vm._s(item.address))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }